import { FC } from 'react';
import { InlineNotification, Link } from '@carbon/react';
import { CheckmarkFilled } from '@carbon/react/icons';
import { entityIdLabel } from 'utils/entity-id';
import type { EntityCard } from './types';
import { ENTITY_TYPE_LABEL } from './reconcile/types';
import style from './party-detail.module.scss';

interface Props {
  entity: EntityCard;
  provisional: boolean;
}

export const ConfirmedMatchBanner: FC<Props> = ({ entity, provisional }) => {
  if (provisional) {
    return (
      <InlineNotification
        kind="warning"
        lowContrast
        hideCloseButton
        title="Successfully matched into an Imported entity —"
        subtitle="To complete the match, select a canonical Individual or Organization from the suggestions, or Add as New the Staged Deduplicated Result."
        className={style.provisionalBanner}
      />
    );
  }

  return (
    <div className={style.confirmed} role="status">
      <div className={style.confirmedIcon}>
        <CheckmarkFilled size={20} />
      </div>
      <div className={style.confirmedBody}>
        <p className={style.confirmedLabel}>Confirmed Entity Match</p>
        <Link href={`/entities/${entity.id}`} className={style.confirmedName}>
          {entity.name ?? '—'}
        </Link>
        <div className={style.confirmedMeta}>
          <span>{entityIdLabel(entity.id)}</span>
          <span>{ENTITY_TYPE_LABEL[entity.type]}</span>
          {entity.primaryAddress?.fullText && (
            <span>{entity.primaryAddress.fullText}</span>
          )}
        </div>
      </div>
    </div>
  );
};
